const safePause = (el) => {
	try {
		el && el.pause();
	} catch (_) {}
};

const resetLater = (el) => {
	// resetting immediately can interrupt a pending play(); do it async
	setTimeout(() => {
		try {
			if (el) el.currentTime = 0;
		} catch (_) {}
	}, 0);
};

/**
 * Toggle play/pause for a target <audio>, pausing all others in the pool.
 * - target: HTMLAudioElement
 * - pool: map/object of {id: HTMLAudioElement}
 * - onErrorPlay: optional error handler
 */
export default function playPause(target, pool = {}, errorPlay) {
	if (!target) return;

	// Toggle OFF
	if (!target.paused && !target.ended) {
		safePause(target);
		resetLater(target);
		return;
	}

	// Pause others first (but never the target)
	try {
		Object.keys(pool || {}).forEach((k) => {
			const el = pool[k];
			if (!el || el === target) return;
			if (!el.paused) safePause(el);
			resetLater(el);
		});
	} catch (_) {}

	// Let pauses flush before playing the target
	Promise.resolve().then(() => {
		const p = target.play();
		if (p && typeof p.catch === 'function') {
			p.catch((err) => {
				// Expected when something else pauses us quickly
				if (err && (err.name === 'AbortError' || err.code === 20))
					return;
				if (typeof onErrorPlay === 'function') errorPlay();
				else console.log('play() failed', err);
			});
		}
	});
}
